var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isExistItems)?_c('not-exist-schedule-items'):_c('ul',{staticClass:"agenda-list"},[_vm._l((_vm.items),function(item){return [_c('agenda-details',{key:item.id,attrs:{"item":item}})]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }